// extracted by mini-css-extract-plugin
module.exports = {"container":"TabProductAssignerManual_container__2Svfr","customPhotoCell":"TabProductAssignerManual_customPhotoCell__2kCVt"};